@if (article && article.id) {
  <h4>{{ 'REPLACEMENT' | translate }}</h4>
}
@if (article && article.id) {
  <app-article-card [article]="article" class="card d-flex col-lg-8 col-xl-6 col-xs-12 col-sm-8 col-md-8 align-items-stretch" [isReplacement]="true"></app-article-card>
}
